<template>
  <div>
    <p v-if="RetMsg">出现错误：{{RetMsg}}</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import storage from "../../common/utils/storage";
export default {
  name: 'Authorize',
  data() {
    return {
      RetMsg: ''
    }
  },
  computed: {
    code() {
      return this.$route.query.code;
    },
    scope() {
      return this.$route.query.scope;
    }
  },
  created() {
    // 判断微信授权回来
    let url = window.location.href;
    if (url.indexOf("code") != -1) {
      if (url.substr(-11) == "#/authorize") {
        let url1Index = url.indexOf("?");
        let url1 = url.substring(0, url1Index);
        let url2 = url.substring(url1Index, url.length - 11);
        let url3 = url.substr(-11);
        let urlAll = url1.concat(url3, url2);
        window.location.href = urlAll;
      } else {
        this.state = this.$route.query.state;
        let code = this.$route.query.code;
        let scope = storage.getStore('scope');
        if (scope == 'snsapi_base') {
          this.$axios.post('/api/api/web/GetWxUser/GeiUserSilence?code=' + code).then(res => {
            if (res.RetCode == '10000') {
              let data = res.Data;
              this.setOpenid(data.OpenId);
              this.setUserInfo({userInfo: data});
              sessionStorage.setItem("Openid", data.OpenId);
              sessionStorage.setItem('Token', data.Token);
              sessionStorage.setItem('userInfo', JSON.stringify(data));
              
              let lastPath = storage.getStore('lastPath');
              this.$router.replace(lastPath);
            } else {
              this.RetMsg = res.RetMsg;
              this.$toast(res.RetMsg);
            }
          })
        } else {
          this.$axios.get('/api/api/web/GetWxUser/GetUserInfo?code=' + code).then(res => {
            if (res.RetCode == '10000') {
              if (res.Data) {
                sessionStorage.setItem("Openid", res.Data.OpenId);
                sessionStorage.setItem('Token', res.Data.Token);
                sessionStorage.setItem('userInfo', JSON.stringify(res.Data));
                this.setOpenid(res.Data.OpenId);
                this.setUserInfo({userInfo: res.Data});

                let lastPath = storage.getStore('lastPath');
                this.$router.push(lastPath);
              }
            } else {
              this.RetMsg = res.RetMsg;
              this.$toast(res.RetMsg);
            }
          })
        }
      }
    } else {
      this.getAuthCode();
    }
  },
  methods: {
    ...mapActions(['setOpenid', 'setUserInfo']),
    getAuthCode() {
      this.$axios.post('/api/api/web/GetWxUser/GetCode', {
        redirect: process.env.VUE_APP_REDIRECT_URL,
        scope: this.scope
      }).then(res => {
        location.href = res.Data;
      })
    }
  }
}
</script>